import React, { useContext, useEffect, useState } from 'react';
import styles from './user-comments-list.module.scss';
import { WDivider, WStack } from '../../wrappers/wrapper';
import { UserContext } from '../../../contexts/userContext';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import ProfilePhoto from '../../molecules/profile-photo/profile-photo';
import { TArticle, TComment, TUser } from '../../../models/common';
import dbService from '../../../services/database.service';
import helperService from '../../../services/helper.service';
import UserCommentsSkeleton from '../../organisms/user-comments-skeleton/user-comments-skeleton';
import NoContent from 'components/molecules/no-content/no-content';

function UserComments({ userId, handleClose }: { userId: string; handleClose?: Function }) {
  const { user } = useContext(UserContext);
  const [commentData, setCommentData] = useState<TComment[]>([]);
  const [loading, setLoading] = useState(true);
  const navigation = useNavigate();

  useEffect(() => {
    setLoading(true);

    dbService
      .getComments({
        relation: ['reply_to.article', 'article'],
        filter: { owner: userId },
        sort: { _id: -1 },
      })
      .then((res) => setCommentData(res))
      .finally(() => setLoading(false));
  }, []);

  return loading ? <UserCommentsSkeleton /> : UserCommentList(user, commentData, navigation, handleClose);
}

function UserCommentList(
  user: TUser,
  comments: TComment[],
  navigation: NavigateFunction,
  handleClose?: Function
) {
  function handleNavigate(comment: TComment) {
    navigation(helperService.getNavigateLink(comment.article as TArticle));
  }

  if (!comments.length) {
    return (
      <NoContent
        title="There are no comments yet"
        subTitle="Comments by this member will show up here."
      />
    );
  }
  return (
    <WStack className={styles['container']}>
      {comments.map((comment, index) => (
        <WStack key={index} className={styles['comment-container']}>
          <WStack
            onClick={() => {
              handleNavigate(comment);
              handleClose && handleClose();
            }}
          >
            <WStack direction={'row'} alignItems={'center'} spacing={1}>
              <ProfilePhoto user={user} className={styles.avatar}/>
              <div className={styles.metadata}>
                <div className={styles.top}>
                  <div className={styles.article}>
                    <span>Commented on</span>
                    <span>{(comment.article as TArticle)?.title}</span>
                  </div>
                  <span className={styles.time}>
                    {helperService.formatTime(
                      Math.floor(
                        (new Date().getTime() - new Date(comment?.created_at!).getTime()) / 60000
                      )
                    )}
                  </span>
                </div>
                <span className={styles.comment}>{comment.message}</span>
              </div>
            </WStack>
          </WStack>
          {comments[index + 1] && <WDivider className={styles.divider} sx={{ marginY: 1 }} />}
        </WStack>
      ))}
    </WStack>
  );
}

export default UserComments;
